<div id="burials" class="col s12 module-top-gap">
    <app-burial-header
        [isLoading]="isLoading"
        [isApplicationOnline]="isApplicationOnline"
        [currentLocationName]="currentLocationName"
        [locations]="locations"
        [totalBurials]="(burials | burialsSearchFilter: filterValues | burialsSearchText: inputSearchText).length + (applications | burialsSearchFilter: filterValues | burialsSearchText: inputSearchText).length + (drafts | burialsSearchFilter: filterValues | burialsSearchText: inputSearchText).length"
        (newContractClick)="openNewContractButtonClicked()"
        (locationChange)="didChangeLocation()"
        (importContractClick)="importContractClicked()"
        (searchClick)="searchButtonClicked()"
        (filterClick)="filterButtonClicked()">
    </app-burial-header>

    <div class="section"></div>

    <span *ngIf="burials.length > 0 || applications.length > 0 || drafts.length > 0">
        <div class="column center">
            <div class="col s12 page-content">
                <ul class="collapsible z-depth-0" data-collapsible="accordion"
                    style="margin-left: -10px !important; margin-top: 0 !important; margin-bottom: 0 !important; margin-right: 0 !important; padding: 0 !important; border: 0px !important;">
                    <li *ngFor="let index = index; let draft of drafts | burialsSearchFilter: filterValues | burialsSearchText: inputSearchText"
                        class="burials draft">
                        <div class="collapsible-header grey lighten-1"
                            (click)="didSelectDraftWithID(draft.burialData?.qrstring)">
                            <div class="burial-header-content">
                                <i class="material-icons" style="color: #991F26;">drafts</i>
                                <span class="burial-name">{{draft.burialData.inputName}} {{draft.burialData.inputLastName}}<small *ngIf="draft.burialData.entrynumber&&draft.burialData.entrynumber > 0"> ({{draft.burialData.entrynumber}})</small></span>
                                <span class="right grey-text text-darken-3">Entwurf</span>
                            </div>
                        </div>
                        <div class="collapsible-body" style="padding:16px;">
                            <div class="row">
                                <div class="col s12">
                                    <div class="row">
                                        <div class="input-field col s12" *ngIf="draft.burialDocs && (draft.burialDocs.burialorderData || draft.burialDocs.deathcertificateData || draft.burialDocs.deathapprovalData || draft.burialDocs.deathapprovalsecretData || draft.burialDocs.urnrequestData || draft.burialDocs.stuffData)">
                                            <ul class="collection with-header">
                                                <li class="collection-header">
                                                    <h6>Gespeicherte Dokumente</h6>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    *ngIf="draft.burialDocs && draft.burialDocs.burialorderData"
                                                    (click)="openDraftDocument(draft, 'burialorderData')"
                                                    title="Dokument öffnen">
                                                    Antrag auf Ein&auml;scherung
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    *ngIf="draft.burialDocs && draft.burialDocs.deathcertificateData"
                                                    (click)="openDraftDocument(draft, 'deathcertificateData')"
                                                    title="Dokument öffnen">
                                                    Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    *ngIf="draft.burialDocs && draft.burialDocs.deathapprovalData"
                                                    (click)="openDraftDocument(draft, 'deathapprovalData')"
                                                    title="Dokument öffnen">
                                                    Erlaubnis zur Einäscherung
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item"
                                                    *ngIf="draft.burialDocs && draft.burialDocs.deathapprovalsecretData"
                                                    title="Gespeichert (keine Vorschau)">
                                                    Todesbescheinigung (vertraulich)
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    *ngIf="draft.burialDocs && draft.burialDocs.urnrequestData"
                                                    (click)="openDraftDocument(draft, 'urnrequestData')"
                                                    title="Dokument öffnen">
                                                    Urnenanforderung
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    *ngIf="draft.burialDocs && draft.burialDocs.stuffData"
                                                    (click)="openDraftDocument(draft, 'stuffData')"
                                                    title="Dokument öffnen">
                                                    Sonstige Dokumente
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="input-field col s12 center-align"
                                            *ngIf="!draft.burialDocs || (!draft.burialDocs.burialorderData && !draft.burialDocs.deathcertificateData && !draft.burialDocs.deathapprovalData && !draft.burialDocs.deathapprovalsecretData && !draft.burialDocs.urnrequestData && !draft.burialDocs.stuffData)">
                                            <p class="grey-text text-darken-1">Dieser Auftrag ist derzeitig ein lokal gespeicherter Entwurf und muss
                                                noch zum Server &uuml;bertragen werden</p>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 20px;">
                                        <div class="input-field col s12 l6 left-align">
                                            <a class="waves-effect waves-light btn red white-text"
                                                (click)="deleteContractButtonClicked('draft')">
                                                <i class="material-icons left">delete</i>Auftrag l&ouml;schen
                                            </a>
                                        </div>
                                        <div class="input-field col s12 l6 right-align" style="display: flex; align-items: center; justify-content: flex-end; gap: 15px;">
                                            <div class="preloader-wrapper small active" *ngIf="isOptionsLoading">
                                                <div class="spinner-layer spinner-green-only">
                                                    <div class="circle-clipper left">
                                                        <div class="circle"></div>
                                                    </div>
                                                    <div class="gap-patch">
                                                        <div class="circle"></div>
                                                    </div>
                                                    <div class="circle-clipper right">
                                                        <div class="circle"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h3 class="action redesign prefixed dropdown-button-forms"
                                                attr.data-activates="draftsdropdown{{index}}"
                                                *ngIf="!isOptionsLoading" style="margin: 0;">Optionen
                                            </h3>
                                            <ul id="draftsdropdown{{index}}" class="dropdown-content">
                                                <li>
                                                    <a (click)="printContractButtonClicked('application')">Auftrag
                                                        drucken</a>
                                                </li>
                                                <li>
                                                    <a
                                                        (click)="printCasketLabelButtonClicked('application')">Sargetikett</a>
                                                </li>
                                                <li>
                                                    <a
                                                        (click)="printPickupButtonClicked('application')">&Uuml;berf&uuml;hrungsformular</a>
                                                </li>
                                            </ul>
                                            <h3 class="redesign action prefixed"
                                                (click)="openContractButtonClicked()" *ngIf="!isOptionsLoading" style="margin: 0;">
                                                <span class="hide-on-small-only">Bearbeiten / Senden</span>
                                                <span class="hide-on-med-and-up">Bearbeiten</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li *ngFor="let index = index; let application of applications | burialsSearchFilter: filterValues | burialsSearchText: inputSearchText"
                        class="burials application">
                        <div class="collapsible-header grey lighten-1"
                            (click)="didSelectApplicationWithID(application.burialData.qrstring)">
                            <div class="burial-header-content">
                                <i class="material-icons" style="color: #991F26;">hourglass_empty</i>
                                <span class="burial-name">{{application.burialData.inputName}} {{application.burialData.inputLastName}}<small *ngIf="application.burialData.entrynumber&&application.burialData.entrynumber > 0"> ({{application.burialData.entrynumber}})</small></span>
                                <span class="right grey-text text-darken-3 hide-on-small-only">Auftrag befindet sich in der Übermittlung</span>
                                <span class="right grey-text text-darken-3 hide-on-med-and-up">Eingang</span>
                            </div>
                        </div>
                        <div class="collapsible-body" style="padding:16px;">
                            <div class="row">
                                <div class="col s12">
                                    <div class="row">
                                        <div class="input-field col s12" *ngIf="application.notifyType!='IMPORT' || application.burialDocs.length > 0">
                                            <ul class="collection with-header">
                                                <li class="collection-header">
                                                    <h6>Notwendige Unterlagen</h6>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('burialorderData', 'application')"
                                                    *ngIf="!application.burialDocs || !application.burialDocs.burialorderData">
                                                    Antrag auf Ein&auml;scherung
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('burialorderData', 'application')"
                                                    *ngIf="application.burialDocs && application.burialDocs.burialorderData">
                                                    Antrag auf Ein&auml;scherung
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('deathcertificateData', 'application')"
                                                    *ngIf="!application.burialDocs || !application.burialDocs.deathcertificateData">Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('deathcertificateData', 'application')"
                                                    *ngIf="application.burialDocs && application.burialDocs.deathcertificateData">Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('deathapprovalData', 'application')"
                                                    *ngIf="!application.burialDocs || !application.burialDocs.deathapprovalData">Erlaubnis zur Einäscherung
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('deathapprovalData', 'application')"
                                                    *ngIf="application.burialDocs && application.burialDocs.deathapprovalData">Erlaubnis zur Einäscherung
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('deathapprovalsecretData', 'application')"
                                                    *ngIf="!application.burialDocs || !application.burialDocs.deathapprovalsecretData">
                                                    Todesbescheinigung (vertraulich)
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('deathapprovalsecretData', 'application')"
                                                    *ngIf="application.burialDocs && application.burialDocs.deathapprovalsecretData">
                                                    Todesbescheinigung (vertraulich)
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('urnrequestData', 'application')"
                                                    *ngIf="!application.burialDocs || !application.burialDocs.urnrequestData">Urnenanforderung
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('urnrequestData', 'application')"
                                                    *ngIf="application.burialDocs && application.burialDocs.urnrequestData">Urnenanforderung
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('stuffData', 'application')"
                                                    *ngIf="!application.burialDocs || !application.burialDocs.stuffData">Sonstige Dokumente
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('stuffData', 'application')"
                                                    *ngIf="application.burialDocs && application.burialDocs.stuffData">Sonstige Dokumente
                                                    <span class="right">
                                                        <i class="material-icons" style="color: #991F26;">archive</i>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="input-field col s12 center-align"
                                            *ngIf="application.notifyType=='IMPORT'">
                                            <p>Dieser Auftrag ist derzeitig ein lokal gespeicherter Entwurf und muss
                                                noch zum Server &uuml;bertragen werden</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12 l6 left-align">
                                            <a class="waves-effect waves-light btn red white-text"
                                                (click)="deleteContractButtonClicked('application')"
                                                *ngIf="application.notifyType=='IMPORT'">L&ouml;schen
                                            </a>
                                        </div>
                                        <div class="input-field col s12 l6 right-align">
                                            <div class="preloader-wrapper small active" *ngIf="isOptionsLoading">
                                                <div class="spinner-layer spinner-green-only">
                                                    <div class="circle-clipper left">
                                                        <div class="circle"></div>
                                                    </div>
                                                    <div class="gap-patch">
                                                        <div class="circle"></div>
                                                    </div>
                                                    <div class="circle-clipper right">
                                                        <div class="circle"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h3 class="action redesign prefixed dropdown-button-forms"
                                                attr.data-activates="applicationsdropdown{{index}}"
                                                *ngIf="!isOptionsLoading">Optionen
                                            </h3>
                                            <ul id="applicationsdropdown{{index}}" class="dropdown-content">
                                                <li>
                                                    <a (click)="printContractWithSignature('application')">Unterschreiben</a>
                                                </li>
                                                <li>
                                                    <a (click)="printContractButtonClicked('application')">Auftrag Drucken</a>
                                                </li>
                                                <li>
                                                    <a (click)="printCasketLabelButtonClicked('application')">Sargetikett</a>
                                                </li>
                                                <li>
                                                    <a (click)="printPickupButtonClicked('application')">&Uuml;berf&uuml;hrungsformular</a>
                                                </li>
                                              
                                               
                                            </ul>
                                            <h3 class="redesign action prefixed" style="margin-left: 20px"
                                                (click)="openContractButtonClicked()" *ngIf="!isOptionsLoading">
                                                <span class="hide-on-small-only">Bearbeiten / Senden</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li *ngFor="let index = index; let burial of burials | burialsSearchFilter: filterValues | burialsSearchText: inputSearchText"
                        class="burials burial">
                        <div class="collapsible-header"
                            [ngClass]="{
                                'unconfirmed': !burial.htmlHeaderClass || burial.htmlHeaderClass == 'unconfirmed', 
                                'on-hold': burial.htmlHeaderClass == 'on-hold', 
                                'confirmed': burial.htmlHeaderClass == 'confirmed', 
                                'isWhite': burial.htmlHeaderClass == 'isWhite'
                                }"
                            (click)="didSelectBurialWithID(burial.fid)">
                            <div class="burial-header-content">
                                <i class="material-icons" [ngClass]="{
                                    'unconfirmed-icon': !burial.htmlHeaderClass || burial.htmlHeaderClass == 'unconfirmed',
                                    'on-hold-icon': burial.htmlHeaderClass == 'on-hold',
                                    'confirmed-icon': burial.htmlHeaderClass == 'confirmed'
                                }" style="color: #991F26;">
                                    {{!burial.htmlHeaderClass || burial.htmlHeaderClass == 'unconfirmed' ? 'schedule' : 
                                      burial.htmlHeaderClass == 'on-hold' ? 'pause_circle' : 
                                      burial.htmlHeaderClass == 'confirmed' ? 'check_circle' : 'assignment'}}
                                </i>
                                <div class="burial-name">
                                    <h3 class="redesign">{{burial.v_frontname}} {{burial.v_lastname}}<small *ngIf="burial.entrynumber&&burial.entrynumber > 0"> ({{burial.entrynumber}})</small></h3>
                                </div>
                                <h3 class="redesign" style="text-align: end;"> {{burial.contractName}}<small
                                        class="hide-on-small-only"
                                        *ngIf="burial.contractStateID >= '40' && burial.burialnumber && burial.burialnumber > 0">
                                        ({{burial.burialnumber}})</small></h3>
                            </div>
                        </div>
                        <div class="collapsible-body" style="padding:16px;">
                            <div class="row">
                                <div class="col s12">
                                    <div class="row">
                                        <div class="col s12">
                                            <span *ngIf="burial.d_deliveryid && burial.d_deliveryid.length > 0" class="shipping-info">
                                                <div class="card">
                                                    <div class="card-content">
                                                        <div class="card-title">
                                                            <i class="material-icons" style="color: #991F26;">local_shipping</i>
                                                            <span>Versandinformationen</span>
                                                        </div>
                                                        <div class="shipping-details">
                                                            <span *ngIf="burial.d_departmentdate && burial.d_departmentdate.length > 0" class="shipping-date">
                                                                <i class="material-icons" style="color: #991F26;">event</i>
                                                                Versendet am: {{burial.d_departmentdate}}
                                                            </span>
                                                            <div class="tracking-number">
                                                                <i class="material-icons" style="color: #991F26;">track_changes</i>
                                                                Trackingnummer:
                                                                <a href="https://order.general-overnight.com/ax4/control/customer_service?shId={{burial.d_deliveryid}}&hash=JMJyKOfE1v&lang=de&ActionCollectInformation=GO%21"
                                                                    target="_blank"
                                                                    class="dfg-color-text">{{burial.d_deliveryid}}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                            <div class="row">
                                                <div class="input-field col s12">
                                                    <h6><b>Notwendige Unterlagen</b></h6>
                                                </div>
                                            </div>
                                            <ul class="collection">
                                                <li class="collection-item">
                                                    <div class="document-content">
                                                        <i class="material-icons" style="color: #991F26;">whatshot</i>
                                                        <span>Einäscherungsdatum</span>
                                                    </div>
                                                    <div class="right">
                                                        <span *ngIf="burial.burial_date || burial.burialdate || burial.cremationDate" class="cremation-date-info">
                                                            {{(burial.burial_date || burial.burialdate || burial.cremationDate) | dateFormat}}
                                                        </span>
                                                        <span *ngIf="!burial.burial_date && !burial.burialdate && !burial.cremationDate" class="cremation-date-info not-done">
                                                            Noch nicht erfolgt
                                                        </span>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_burialorderData', 'burial')"
                                                    *ngIf="!burial.i_burialorderData && (!burial.i_burialorderType || burial.i_burialorderType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons" style="color: #991F26;">description</i>
                                                        Antrag auf Ein&auml;scherung
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_burialorderData', 'burial')"
                                                    *ngIf="burial.i_burialorderData && (!burial.i_burialorderType || burial.i_burialorderType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        Antrag auf Ein&auml;scherung
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_burialorderData', 'burial')"
                                                    *ngIf="burial.i_burialorderType==1">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        Antrag auf Ein&auml;scherung
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                        <i class="material-icons green-text">done</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_burialorderData', 'burial')"
                                                    *ngIf="burial.i_burialorderType==2">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        Antrag auf Ein&auml;scherung
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3"
                                                            *ngIf="burial.i_burialorderData">archive</i>
                                                        <i class="material-icons red-text">warning</i>
                                                    </div>
                                                </li>

                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathcertificateData', 'burial')"
                                                    *ngIf="!burial.i_deathcertificateData && (!burial.i_deathcertificateType || burial.i_deathcertificateType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)</span>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathcertificateData', 'burial')"
                                                    *ngIf="burial.i_deathcertificateData && (!burial.i_deathcertificateType || burial.i_deathcertificateType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathcertificateData', 'burial')"
                                                    *ngIf="burial.i_deathcertificateType==1">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                        <i class="material-icons green-text">done</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathcertificateData', 'burial')"
                                                    *ngIf="burial.i_deathcertificateType==2">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3"
                                                            *ngIf="burial.i_deathcertificateData">archive</i>
                                                        <i class="material-icons red-text">warning</i>
                                                    </div>
                                                </li>

                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalData', 'burial')"
                                                    *ngIf="!burial.i_deathapprovalData && (!burial.i_deathapprovalType || burial.i_deathapprovalType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Erlaubnis zur Einäscherung</span>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalData', 'burial')"
                                                    *ngIf="burial.i_deathapprovalData && (!burial.i_deathapprovalType || burial.i_deathapprovalType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Erlaubnis zur Einäscherung</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalData', 'burial')"
                                                    *ngIf="burial.i_deathapprovalType==1">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Erlaubnis zur Einäscherung</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                        <i class="material-icons green-text">done</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalData', 'burial')"
                                                    *ngIf="burial.i_deathapprovalType==2">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Erlaubnis zur Einäscherung</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3"
                                                            *ngIf="burial.i_deathapprovalData">archive</i>
                                                        <i class="material-icons red-text">warning</i>
                                                    </div>
                                                </li>

                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalsecretData', 'burial')"
                                                    *ngIf="!burial.i_deathapprovalsecretData && (!burial.i_deathapprovalsecretType || burial.i_deathapprovalsecretType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Todesbescheinigung (vertraulich)</span>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalsecretData', 'burial')"
                                                    *ngIf="burial.i_deathapprovalsecretData && (!burial.i_deathapprovalsecretType || burial.i_deathapprovalsecretType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Todesbescheinigung (vertraulich)</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalsecretData', 'burial')"
                                                    *ngIf="burial.i_deathapprovalsecretType==1">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Todesbescheinigung (vertraulich)</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                        <i class="material-icons green-text">done</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_deathapprovalsecretData', 'burial')"
                                                    *ngIf="burial.i_deathapprovalsecretType==2">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Todesbescheinigung (vertraulich)</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3"
                                                            *ngIf="burial.i_deathapprovalsecretData">archive</i>
                                                        <i class="material-icons red-text">warning</i>
                                                    </div>
                                                </li>

                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_urnrequestData', 'burial')"
                                                    *ngIf="!burial.i_urnrequestData && (!burial.i_urnrequestType || burial.i_urnrequestType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Urnenanforderung</span>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_urnrequestData', 'burial')"
                                                    *ngIf="burial.i_urnrequestData && (!burial.i_urnrequestType || burial.i_urnrequestType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Urnenanforderung</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_urnrequestData', 'burial')"
                                                    *ngIf="burial.i_urnrequestType==1">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Urnenanforderung</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                        <i class="material-icons green-text">done</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_urnrequestData', 'burial')"
                                                    *ngIf="burial.i_urnrequestType==2">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Urnenanforderung</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3"
                                                            *ngIf="burial.i_urnrequestData">archive</i>
                                                        <i class="material-icons red-text">warning</i>
                                                    </div>
                                                </li>

                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_stuffData', 'burial')"
                                                    *ngIf="!burial.i_stuffData && (!burial.i_stuffType || burial.i_stuffType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sonstige Dokumente</span>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_stuffData', 'burial')"
                                                    *ngIf="burial.i_stuffData && (!burial.i_stuffType || burial.i_stuffType==0)">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sonstige Dokumente</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_stuffData', 'burial')"
                                                    *ngIf="burial.i_stuffType==1">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sonstige Dokumente</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3">archive</i>
                                                        <i class="material-icons green-text">done</i>
                                                    </div>
                                                </li>
                                                <li class="collection-item cursor-link"
                                                    (click)="takeImageClicked('i_stuffData', 'burial')"
                                                    *ngIf="burial.i_stuffType==2">
                                                    <div class="document-content">
                                                        <i class="material-icons">description</i>
                                                        <span>Sonstige Dokumente</span>
                                                    </div>
                                                    <div class="right">
                                                        <i class="material-icons grey-text text-darken-3"
                                                            *ngIf="burial.i_stuffData">archive</i>
                                                        <i class="material-icons red-text">warning</i>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="row col s12 right-align" style="justify-content: flex-end;">
                                            <div class="preloader-wrapper small active" *ngIf="isOptionsLoading">
                                                <div class="spinner-layer spinner-green-only">
                                                    <div class="circle-clipper left">
                                                        <div class="circle"></div>
                                                    </div>
                                                    <div class="gap-patch">
                                                        <div class="circle"></div>
                                                    </div>
                                                    <div class="circle-clipper right">
                                                        <div class="circle"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h3 *ngIf="burial.entrynumber && !isOptionsLoading && isApplicationOnline"
                                                class="redesign action prefixed" style="margin-right: 20px"
                                                (click)="openDocumentTab(burial.entrynumber)">
                                                <i class="material-icons">folder</i>
                                                Dokumente
                                            </h3>

                                            <h3 class="redesign action prefixed dropdown-button-forms"
                                                style="margin-right: 20px"
                                                attr.data-activates="burialsdropdown{{index}}"
                                                *ngIf="!isOptionsLoading">Optionen
                                            </h3>
                                            <ul id="burialsdropdown{{index}}" class="dropdown-content">
                                                <li>
                                                    <a (click)="printContractWithSignature('burial')">
                                                        <i class="material-icons">edit</i>
                                                        Unterschreiben und Drucken
                                                    </a>
                                                </li>
                                                <li>
                                                    <a (click)="printContractButtonClicked('burial')">
                                                        <i class="material-icons">print</i>
                                                        Nur Drucken
                                                    </a>
                                                </li>
                                                <li>
                                                    <a (click)="printCasketLabelButtonClicked('burial')">
                                                        <i class="material-icons">local_offer</i>
                                                        Sargetikett
                                                    </a>
                                                </li>
                                                <li>
                                                    <a (click)="printPickupButtonClicked('burial')">
                                                        <i class="material-icons">local_shipping</i>
                                                        &Uuml;berf&uuml;hrungsformular
                                                    </a>
                                                </li>
                                            </ul>
                                            <h3 class="redesign action prefixed" (click)="openDetailsButtonClicked(burial)"
                                                *ngIf="!isOptionsLoading">
                                                <i class="material-icons">info</i>
                                                <span class="hide-on-small-only">Sterbefalldetails &ouml;ffnen</span>
                                                <span class="show-on-small-only">Details</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="juvo-spinner center" *ngIf="isLoading" style="margin-top: 32px">
                    <div class="preloader-wrapper big active">
                        <div class="spinner-layer spinner-green-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section"></div>
                <div class="section"></div>
                <div style="text-align: center;">
                    <h2 class="redesign action prefixed" (click)="loadMoreButtonClicked()" style="margin-top: 18px"
                        *ngIf="!isLoading">Mehr laden</h2>
                </div>
            </div>
        </div>
    </span>

    <span *ngIf="burials.length < 1 && applications.length < 1 && drafts.length < 1">
        <div class="section"></div>
        <div class="section"></div>
        <h5 class="center grey-text" *ngIf="!isLoading">Es wurden keine Bestattungen gefunden</h5>
        <h5 class="center grey-text" *ngIf="isLoading">Bestattungen werden geladen</h5>
    </span>

    <div id="burialdetailmodal" class="modal">
        <div class="modal-content">
            <div class="row space-between">
                <h4 *ngIf="selectedBurial">{{selectedBurial.v_frontname}} {{selectedBurial.v_lastname}}<br><small
                        *ngIf="selectedBurial.burialnumber">
                        <span class="grey-text">({{selectedBurial.burialnumber}})</span>
                    </small></h4>

                <a class="btn-flat" onclick="closeModalWithID('burialdetailmodal')"
                    style="margin: 0 !important; padding: 0 !important;">
                    <i class="material-icons large">close</i>
                </a>
            </div>

            <div class="row space-between center" *ngIf="burialAddModalTabBarVisible" style="margin-top: 50px">
                <h3 class="redesign cursor-pointer" (click)="didSelectTabWithID('personal_data')"
                    [ngClass]="{'active': selectedTab() == 'personal_data'}">
                    EINÄSCHERUNGSAUFTRAG</h3>
                <h3 class="redesign cursor-pointer" (click)="didSelectTabWithID('urn_delivery')"
                    [ngClass]="{'active': selectedTab() == 'urn_delivery'}">SERVICE &
                    TERMINE</h3>
            </div>
            <div class="row">
                <div class="col s12">
                    <div class="section"></div>
                    <!-- ROUTER OUTLET -->
                    <app-application *ngIf="selectedTab()=='personal_data'"></app-application>
                    <app-dates *ngIf="selectedTab()=='urn_delivery'"></app-dates>
                </div>
            </div>
            <div class="row right" *ngIf="showDetailSendButton()">
                <div class="col s12 right-align">
                    <h2 class="redesign action prefixed" (click)="sendDataButtonClicked(true)"
                        *ngIf="isApplicationOnline">Senden</h2>
                    <h2 class="redesign action prefixed" (click)="sendDataButtonClicked(true)"
                        *ngIf="!isApplicationOnline">Offline</h2>
                </div>
            </div>
        </div>
    </div>

    <div id="burialaddmodal" class="dialog-container" [class.active]="isDialogOpen">
        <div class="dialog-overlay" (click)="cancelDataButtonClicked()"></div>
        <div class="dialog-content">
            <div id="qrCodeView" class="right"
                style="width:100px;height:100px;margin-bottom:16px;visibility:hidden;position:absolute;top:-9999px;"></div>
            <div class="dialog-header">
                <h1 class="redesign action">
                    {{burialAddModalTitle}}
                    <span *ngIf="fullLastName().length > 0 || fullName().length > 0"><br><small>
                            <span class="grey-text">({{fullLastName()}} {{fullName()}})</span>
                        </small></span>
                </h1>

                <a class="btn-flat" (click)="cancelDataButtonClicked()"
                    style="margin: 0 !important; padding: 0 !important;">
                    <i class="material-icons large">close</i>
                </a>
            </div>

            <select id="inputAddLocation" class="inputAddLocation browser-default">
                <option value="0" selected>{{currentLocationName}}</option>
                <option *ngFor="let location of locations" value="{{location.id}}">
                    {{location.bestatter}}</option>
            </select>

            <div class="row space-between center" *ngIf="burialAddModalTabBarVisible"
                style="margin-top: 50px; flex-wrap: wrap;">
                <div class="progress-container" style="width: 100%; margin-bottom: 20px;">
                    <div class="progress">
                        <div class="determinate" [style.width.%]="(getCurrentStep() / totalSteps) * 100" style="background-color: #991F26;"></div>
                    </div>
                    <div class="step-indicators" style="display: flex; justify-content: space-between; margin-top: 5px;">
                        <span [ngClass]="{'active': getCurrentStep() >= 1}" [style.color]="getCurrentStep() >= 1 ? '#991F26' : ''">1. Antrag auf Einäscherung</span>
                        <span [ngClass]="{'active': getCurrentStep() >= 2}" [style.color]="getCurrentStep() >= 2 ? '#991F26' : ''">2. Dokumente</span>
                        <span [ngClass]="{'active': getCurrentStep() >= 3}" [style.color]="getCurrentStep() >= 3 ? '#991F26' : ''">3. Service & Termine</span>
                    </div>
                </div>
                <h3 class="redesign cursor-pointer" (click)="didSelectTabWithID('application')"
                    [ngClass]="{'active': selectedTab() == 'application', 'disabled': getCurrentStep() < 1}">
                    <span class="hide-on-small-only">EINÄSCHERUNGS</span>AUFTRAG
                </h3>
                <h3 class="redesign cursor-pointer" (click)="didSelectTabWithID('attachments')"
                    [ngClass]="{'active': selectedTab() == 'attachments', 'disabled': getCurrentStep() < 2}">
                    DOKUMENTE</h3>
                <h3 class="redesign cursor-pointer" (click)="didSelectTabWithID('dates')"
                    [ngClass]="{'active': selectedTab() == 'dates', 'disabled': getCurrentStep() < 3}">
                    <span class="hide-on-small-only">SERVICE &</span>TERMINE</h3>
            </div>

            <div class="dialog-body">
                <!-- ROUTER OUTLET -->
                <app-application *ngIf="selectedTab()=='application'"></app-application>
                <app-attachments *ngIf="selectedTab()=='attachments'"></app-attachments>
                <app-dates *ngIf="selectedTab()=='dates'"></app-dates>

                <div class="row" style="margin-top: 30px; height: 50px">
                    <div class="input-field col s12">
                        <div class="switch">
                            <label class="black-text">
                                <input id="inputSendMail" type="checkbox" [(ngModel)]="inputSendMail">
                                <span class="lever"></span>
                                <span class="lever-text">Ich m&ouml;chte f&uuml;r diesen Auftrag Statusupdates per
                                    E-Mail erhalten.</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 20px; margin-bottom: 60px; height: 80px">
                    <div class="input-field col s12">
                        <div class="switch">
                            <label class="{{agreementTextColor}}">
                                <input id="inputAgreement" type="checkbox" [(ngModel)]="inputAgreement">
                                <span class="lever"></span>
                                <span class="lever-text">Als Bestatter gew&auml;hrleiste ich, die ordnungsgem&auml;ße
                                    &Uuml;bergabe des Sarges an das Krematorium. Des Weiteren
                                    habe ich den Inhalt der
                                    <a href="https://krematorium-am-limes.de/datenschutz/" target="_blank"
                                        class="action">Datenschutzerkl&auml;rung</a>
                                    zustimmend zur Kenntnis genommen.
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dialog-footer">
                <button class="waves-effect waves-light btn-flat" (click)="cancelDataButtonClicked()">Abbrechen</button>
                <button class="waves-effect waves-light btn-flat" (click)="saveAsDraftButtonClicked()" style="margin-right: 10px;">Als Entwurf speichern</button>
                <button *ngIf="currentStep > 1" class="waves-effect waves-light btn-flat" (click)="goToPreviousStep()">Zurück</button>
                <button *ngIf="currentStep < totalSteps" class="waves-effect waves-light btn" (click)="goToNextStep()">Weiter</button>
                <button *ngIf="currentStep === totalSteps" class="waves-effect waves-light btn" (click)="sendDataButtonClicked()">Senden</button>
            </div>
        </div>
    </div>

    <div id="confirmCloseModal" class="dialog-container" [class.active]="isConfirmDialogOpen">
        <div class="dialog-overlay" (click)="cancelCloseModal()"></div>
        <div class="dialog-content">
            <h4>Bestätigung</h4>
            <p>Möchten Sie das Formular wirklich schließen? Nicht gespeicherte Daten können dabei verloren gehen.</p>
            <div class="dialog-footer">
                <button class="modal-close waves-effect waves-light btn-flat" (click)="cancelCloseModal()">Abbrechen</button>
                <button class="waves-effect waves-light btn red" (click)="confirmCloseModal()">Schließen</button>
            </div>
        </div>
    </div>

    <div id="filedetailmodal" class="modal big-modal">
        <div class="modal-content edge-to-edge">
            <span class="center-align" *ngIf="!filePreviewObject">
                <span *ngIf="isDocumentLoading">
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="juvo-spinner">
                        <div class="preloader-wrapper big active">
                            <div class="spinner-layer spinner-green-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section"></div>
                    <p>Lade Dokument...</p>
                </span>
                <span *ngIf="!isDocumentLoading">
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <p>Es wurde kein Dokument gefunden</p>
                </span>
            </span>
            <span *ngIf="filePreviewObject">
                <object id="pdfDetailObject" [data]="filePreviewObject | safeBaseUrl: 'application/pdf'"
                    class="pdf-detail-object"></object>
            </span>
        </div>
    </div>

    <div id="historymodal" class="modal">
        <div class="modal-content">
            <h4>Historie</h4>
            <span class="center-align" *ngIf="historyEntries.length<1">
                <span *ngIf="isHistoryLoading">
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="juvo-spinner">
                        <div class="preloader-wrapper big active">
                            <div class="spinner-layer spinner-green-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section"></div>
                    <p>Lade Eintr&auml;ge...</p>
                </span>
                <span *ngIf="!isHistoryLoading">
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <p>Es wurden keine Eintr&auml;ge gefunden</p>
                </span>
            </span>
            <span *ngIf="historyEntries.length>0">
                <ul class="collection with-header" *ngFor="let entry of historyEntries">
                    <li class="collection-header" style="font-weight:bold;">Ge&auml;ndert von {{entry.userName}}
                        <span class="right">{{entry.entryDate}}</span>
                    </li>
                    <ng-container *ngFor="let value of entry.payload.value">
                        <li class="collection-item black-text" *ngIf="!value.payload">
                            <span style="font-weight:bold;">{{value.name}}:</span>
                            {{value.value}}
                        </li>
                        <ng-container *ngFor="let value of entry.payload.value"></ng-container>
                        <li class="collection-item black-text cursor-link" *ngIf="value.payload"
                            (click)="openPDFFromHistory(value.payload)">
                            <span style="font-weight:bold;">{{value.name}}:</span>
                            {{value.value}}
                        </li>
                    </ng-container>
                </ul>
            </span>
        </div>
    </div>
    <!--OLD BURIALS PART END **********************************************************************-->
</div>

<div id="contractprintmodal" class="modal" style="min-height: inherit !important; top: 15vh !important;">
    <div class="modal-content">
        <h4>Auftrag drucken</h4>
        <div class="row">
            <div class="col s12">
                <select id="contractPrintLocation" class="browser-default contractPrintLocation">
                    <option value="0" selected>Beisetzungsort w&auml;hlen</option>
                    <option value="null" disabled>Beisetzung in Dachsenhausen</option>
                    <option value="15">Rasenfriedhof</option>
                    <option value="48">Blumengarten</option>
                    <option value="8">Rheinhöhen-Ruhewald Braubach</option>
                    <option value="46">Unser Hafen</option>
                    <option value="49">Raum der stille</option>
                    <option value="null" disabled>--------------------------------------------</option>
                    <option value="null" disabled>Beisetzung in Deutschland</option>
                    <option value="1">Neidenbach</option>
                    <option value="2">Mittelreidenbach</option>
                    <option value="5">Zell</option>
                    <option value="6">Essen-Frintrop</option>
                    <option value="7">Cadenberge</option>
                    <option value="10">Bad Feilnbach-Derndorf</option>
                    <option value="12">PORTAJOM Bornheim-Merten</option>
                    <option value="13">PORTAJOM Essen-Frintrop</option>
                    <option value="14">Bornheim</option>
                    <option value="31">Kabelsketal</option>
                    <option value="41">Streu Breda</option>
                    <option value="42">Streu Chaam</option>
                    <option value="43">Horrweiler</option>
                    <option value="47">Unser Hafen Essen</option>
                    <option value="null" disabled>--------------------------------------------</option>
                    <option value="null" disabled>Beisetzung auf See</option>
                    <option value="34">See Krautsand</option>
                    <option value="35">See Strande</option>
                    <option value="36">See Scheveningen</option>
                    <option value="37">See Rhein</option>
                    <option value="38">See Flugzeug</option>
                    <option value="39">See Niendorf</option>
                    <option value="40">See Palma</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <select id="contractPrintType" class="browser-default contractPrintType">
                    <option value="rtk" selected>RTK Antrag</option>
                    <option value="dfg">DFG Antrag</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <select id="contractPrintSubtype" class="browser-default contractPrintSubtype">
                    <option value="0" selected>Antrag auf Beisetzung</option>
                    <option value="1">Antrag auf Ein&auml;scherung und Beisetzung</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12 right-align">
                <a class="waves-effect waves-light btn juvo-color white-text"
                    (click)="sendContractButtonClicked()">Erstellen</a>
            </div>
        </div>
    </div>
</div>

<div id="filtermodal" class="modal" style="min-height: inherit !important; top: 15vh !important;">
    <app-burial-filter
        [filterValues]="filterValues"
        [filterMatchCount]="filterMatchCount"
        [filterInputContractNames]="filterInputContractNames"
        (addFilter)="addFilterValue($event.type, $event.value)"
        (deleteFilter)="deleteFilterValue($event)"
        (clearFilters)="deleteAllFilters()">
    </app-burial-filter>
</div>

<div id="searchmodal" class="modal" style="min-height: inherit !important; top: 15vh !important;">
    <div class="modal-content">
        <a class="btn-flat right" onclick="closeModalWithID('searchmodal')"><i
                class="material-icons large">close</i></a>
        <h4 class="action-color">Suchen</h4>
        <div class="row">
            <div class="input-field col s12">
                <input id="inputSearchText" type="text" class="inputSearchText" [(ngModel)]="inputSearchText"
                    (keyup)="macGyveredDOMReload()">
                <label id="inputSearchTextLabel" for="inputSearchText" class="inputSearchTextLabel active">Suchtext (Es
                    kann nach allen Werten gesucht werden)</label>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12">
                <span class="left"><i class="material-icons redesign action"
                        (click)="clearSearchButtonClicked()">delete</i></span>
            </div>
        </div>
    </div>
</div>

<!--View Divider-->

<div id="infos" class="col s12" style="display: none">
    <!--NEW BURIALS PART **********************************************************************-->
    <router-outlet></router-outlet>
    <!--NEW BURIALS PART END **********************************************************************-->
</div>

<input id="takePictureField" type="file" capture="camera" accept="image/jpeg,image/png,application/pdf"
    (change)="takeImageCallback('takePictureField')" style="visibility:hidden;">
<input id="importField" type="file" (change)="importContractCallback('importField')" accept="application/pdf"
    style="visibility:hidden;">
<div id="root-picker-outlet"></div>

<div id="signaturemodal" class="modal">
    <div class="modal-content">
        <h4>Unterschriften</h4>
        <div class="row">
            <div class="col s12">
                <div class="input-field">
                    <h6>Bestatter (optional)</h6>
                    <div class="signature-pad">
                        <canvas id="bestatterSignature" width="500" height="200"></canvas>
                    </div>
                    <button class="waves-effect waves-light btn-flat" (click)="clearSignature('bestatter')">Löschen</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <div class="input-field">
                    <h6>Auftraggeber (optional)</h6>
                    <div class="signature-pad">
                        <canvas id="angehoerigerSignature" width="500" height="200"></canvas>
                    </div>
                    <button class="waves-effect waves-light btn-flat" (click)="clearSignature('angehoeriger')">Löschen</button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-close waves-effect waves-light btn-flat" (click)="closeSignatureModal()">Abbrechen</button>
            <button class="waves-effect waves-light btn" (click)="saveSignatures()">Speichern</button>
        </div>
    </div>
</div>